"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = exports.RadioGroup = void 0;
var _RadioGroupContext = _interopRequireDefault(require("./RadioGroupContext"));
var _RadioGroupError = require("./RadioGroupError");
var _RadioGroupFormLabel = require("./RadioGroupFormLabel");
var _RadioGroupOption = require("./RadioGroupOption");
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _camelCase = _interopRequireDefault(require("lodash/camelCase"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["title", "value", "name", "error", "children", "options", "loading", "vertical", "onChange", "getOptionLabel", "isOptionDisabled"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    loaderContainer: {
      display: "flex",
      justifyContent: "center",
      padding: "8px"
    },
    label: {
      fontSize: "12px",
      marginBottom: theme.spacing(1)
    }
  };
});
var dataCy = exports.dataCy = "RadioGroup";
var RadioGroup = exports.RadioGroup = function RadioGroup(_ref) {
  var title = _ref.title,
    value = _ref.value,
    name = _ref.name,
    error = _ref.error,
    children = _ref.children,
    options = _ref.options,
    loading = _ref.loading,
    vertical = _ref.vertical,
    onChange = _ref.onChange,
    _ref$getOptionLabel = _ref.getOptionLabel,
    getOptionLabel = _ref$getOptionLabel === void 0 ? function (_ref2) {
      var name = _ref2.name;
      return name;
    } : _ref$getOptionLabel,
    isOptionDisabled = _ref.isOptionDisabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var renderRadio = function renderRadio(option, index) {
    var disabled = (isOptionDisabled === null || isOptionDisabled === void 0 ? void 0 : isOptionDisabled(option)) || false;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioGroupOption.RadioGroupOption, {
      label: getOptionLabel(option),
      value: option.id,
      dataCy: "".concat((0, _camelCase["default"])(option.name), "Radio"),
      disabled: disabled
    }, index);
  };
  var handleChange = function handleChange(event, v) {
    onChange(event, v);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
    component: 'fieldset',
    "data-cy": dataCy,
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioGroupFormLabel.RadioGroupFormLabel, {
      children: title
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormGroup, _objectSpread(_objectSpread({
      row: !vertical
    }, props), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioGroupContext["default"].Provider, {
        value: {
          value: value,
          onChange: handleChange
        },
        children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.loaderContainer,
          "data-cy-role": 'radioGroupLoader',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
            size: 24,
            thickness: 5,
            "data-cy-role": 'circleProgress'
          })
        }) : options ? options.map(renderRadio) : children
      })
    })), error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioGroupError.RadioGroupError, {
      children: error
    }) : null]
  });
};
RadioGroup.propTypes = {
  /**
   * 	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * 	Display group of elements in a compact row.
   */
  row: _propTypes["default"].bool,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * The content of the component.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].func]),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]),
  name: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  options: _propTypes["default"].array,
  onChange: _propTypes["default"].func
};
var _default = exports["default"] = RadioGroup;